import { AbilityCan, AbilitySubjects, UserRole } from '../../enums';
import { IAbilityFunction } from '../abilities.types';
import { ICaslCondition } from '../utils';
import { BeastIntegrationSubject, IBeastIntegrationCalculatedSubject } from './beastIntegrationTypes';

const { CRUD, UPDATE, READ } = AbilityCan;
const { ADMIN, EMPLOYEE } = UserRole;
const { DESPATCH_ADVICE } = BeastIntegrationSubject;

// forbid argument kept for uniform define ability calls
export function defineAbilitiesForBeastIntegration(_allow: IAbilityFunction, _forbid: IAbilityFunction) {
    type SubjectShape = ICaslCondition<IBeastIntegrationCalculatedSubject>;

    const allow = (can: AbilityCan | AbilityCan[], shape: SubjectShape) =>
        _allow(can, AbilitySubjects.BEAST_INTEGRATION, shape);

    allow(CRUD, { relationRole: ADMIN });
    allow(READ, { relationRole: EMPLOYEE });
    allow(UPDATE, { relationRole: EMPLOYEE, subSubject: [DESPATCH_ADVICE] });
}
